export const handleDownloadBatchCSV = (data, totals, total_oper_per_hour, eficienciaOperaciones, eficienciaProductos, porcentajeConformes) => {
    if (!Array.isArray(data) || data.length === 0) {
        alert("No hay datos para exportar.");
        return;
    }

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Fecha,Hora Inicio,Hora Fin,Horas Totales,Cant. Operaciones,Operaciones/Hora,PT OK,PT NC,Eficiencia Operaciones,Eficiencia Productos,% Conformes\n";

    data.forEach((row) => {
        const fecha = new Date(row.date_begin).toISOString().split("T")[0];
        const oper_per_hour = row.total_hr_batch > 0 ? (row.cant_oper / row.total_hr_batch).toFixed(2) : "0.00";

        csvContent += `${fecha},${row.time_begin},${row.time_end},${row.total_hr_batch},${row.cant_oper},${oper_per_hour},${row.cant_pt_ok},${row.cant_pt_nc},${row.percent_efficiency},${row.product_efficiency},${row.conforming_prod}\n`;
    });

    // Agregar totales
    csvContent += `TOTAL,,,,${totals.total_oper_batch.toFixed(2)},${total_oper_per_hour},${totals.cant_pt_ok},${totals.cant_pt_nc},${eficienciaOperaciones},${eficienciaProductos},${porcentajeConformes}%\n`;

    // Descargar
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "batch_summary_report.csv");
    document.body.appendChild(link);
    link.click();
};
